import { Color } from '@/modules/core/app/enums/Color';
import { removeAccents } from '/@/modules/core/app/helpers/StringHelper';

export function getColorPalette(): string[] {
  return [
    Color.DEEP_SKY_BLUE, // A
    Color.SLATE_GRAY, // B
    Color.DEEP_INDIGO, // C
    Color.BRICK_RED, // D
    Color.PLUM_PURPLE, // E`
    Color.MIDNIGHT_PURPLE, // F
    Color.STEEL_BLUE, // G
    Color.EARTH_BROWN, // H
    Color.DUSTY_ROSE, // I
    Color.NEON_PINK, // J
    Color.BRIGHT_CORAL, // K
    Color.EGGPLANT_PURPLE, // L
    Color.OCEAN_BLUE, // M
    Color.TANGERINE, // N
    Color.SUNNY_YELLOW, // O
    Color.RASPBERRY, // P
    Color.EMERALD_GREEN, // Q
    Color.MUTED_AQUA, // R
    Color.SKY_BLUE, // S
    Color.LAVENDER_PURPLE, // T
    Color.FOREST_GREEN_DARK, // U
    Color.WINE_PURPLE, // V
    Color.ROSEWOOD, // W
    Color.CLOUDY_BLUE, // X
    Color.BURNT_SIENNA, // Y
    Color.SLATE_BLUE_GRAY // Z
  ];
}

export function getColorByLetter(letter: string): string {
  return getColorPalette()[removeAccents(letter).toUpperCase().charCodeAt(0) - 65];
}
